import React from "react";

export const MfaChallenge = ({ mfa, mfaCode, setMfaCode, busy, onSubmit, onBack }) => (
  <form onSubmit={onSubmit} className="w-full max-w-md space-y-5" data-testid="mfa-form">
    <div>
      <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Verificação em duas etapas</div>
      <h1 className="font-display font-bold text-3xl text-[#0B2B62] tracking-tight mt-1">Insira seu código 2FA</h1>
      <p className="text-sm text-slate-500 mt-1">Abra seu app autenticador e informe o código de 6 dígitos para <b>{mfa.user.email}</b>.</p>
    </div>
    <input data-testid="mfa-code" value={mfaCode} onChange={(e) => setMfaCode(e.target.value)}
      inputMode="numeric" maxLength={6} placeholder="000000"
      className="w-full px-3 py-3 border border-slate-300 rounded-md text-2xl font-mono tracking-[0.5em] text-center outline-none focus:ring-2 focus:ring-[#0B2B62]" />
    <button data-testid="mfa-submit" disabled={busy || mfaCode.length !== 6} type="submit"
      className="w-full py-3 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 disabled:opacity-40">
      {busy ? "Verificando..." : "Confirmar"}
    </button>
    <button type="button" onClick={onBack} className="text-sm text-slate-500 hover:text-[#0B2B62] w-full">Voltar</button>
  </form>
);
